import { UnscheduledSectionServant } from '../../views/unscheduled_sections/servants/unscheduled_section_servant';
import { ISection, ISectionLabelValue } from '../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
class SectionBadgesController {
  private canAddToWaitlist: boolean = false;
  private displayInReveal: boolean = false;
  private section: ISection;
  private badges: ISectionLabelValue[] = [];
  private VIEWABLE_THRESHOLD: number = 8;
  constructor(private ngUnscheduledSectionServant: UnscheduledSectionServant) {}
  initialize() {
    this.canAddToWaitlist = this.ngUnscheduledSectionServant.canAddToWaitlist(this.section);
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
    this.createBadgesArray();
  }
  createBadgesArray() {
    this.badges = [];
    _4.each(_4.get(this.section, '_section_labels.section_label'), (label: ISectionLabelValue) => {
      this.badges.push({ value: label.value, desc: label.desc });
    });
    if (this.badges.length > this.VIEWABLE_THRESHOLD) {
      this.displayInReveal = true;
    }
  }
  normalizeSectionLabel(text: string) {
    return _4.truncate(_4.startCase(_4.lowerCase(text)), { length: 20 });
  }
}

angular.module('capability-ng-scheduler').component('sectionBadges', {
  templateUrl: 'capability-ng-scheduler/src/components/section_badges/section_badges.html',
  bindings: {
    section: '<'
  },
  controller: SectionBadgesController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_badges/section_badges.ts